import { gql } from '@apollo/client';

export const CREATE_OVERPACK_SCAN_ID = gql`
    mutation CreateOverPackScanId($data: PurchaseOrderPartLocationInput!) {
        createOverPackScanId(data: $data) {
            code
            success
            message
        }
    }`;

export default CREATE_OVERPACK_SCAN_ID;
